import React, { FC } from "react";
import classNames from "classnames";

import { Footer } from "../Footer";
import { Logo } from "../../../components/logo";
import { DashboardMenu } from "../../../components/menu";
import { isMobileMedia } from "../../../utils/media";
import { Button } from "../../../components/common/Button";
import Icon from "../../../components/common/Icon";

type Props = {
  className?: string;
  onClick?: () => void;
};

export const Sidebar: FC<Props> = ({ className, onClick }) => {
  return (
    <div className={classNames("flex flex-col p-4 bg-purple-50", className)}>
      <Logo className="mb-8" width="175px" />

      <DashboardMenu onClick={onClick} />

      {!isMobileMedia() && (
        <Button type="button" className="contact-support-btn mt-8">
          Get Help{" "}
          <Icon
            icon="support_agent"
            size={24}
            className="text-gray-500"
            disableFill
          />
        </Button>
      )}

      {isMobileMedia() && <Footer />}
    </div>
  );
};
